export default __webpack_public_path__ + "static/media/imp1.8d981f81.png";